module.exports = __webpack_public_path__ + "static/media/insta-rhs.85ed9d1e.jpg";